import React from 'react';
import {useSelector} from 'react-redux';
import {t} from '@lingui/core/macro';
import {Navigate} from 'react-router';

import SummaryHeader from 'shared/ui/SummaryHeader/SummaryHeader';
import Email from 'images/email-yellow.png';
import {useEmailConfirmation, getEmailScreenPriority, userSelector} from 'entities/user';
import useBreakpoint from 'shared/lib/hooks/useBreakpoint';

import HeaderEmail from '../HeaderEmail/HeaderEmail';
import AnswerEmail from '../AnswerEmail/AnswerEmail';

import styles from './EmailWarning.module.scss';

const EmailWarning: React.FC = () => {
    const breakpoint = useBreakpoint();
    const user = useSelector(userSelector);
    const confirmEmail = useEmailConfirmation();
    const priority = getEmailScreenPriority(user);

    if (priority !== 'warning') {
        return <Navigate to="/monitors" replace />;
    }

    const emailBold = <span className={styles.bold}>{user?.email}</span>;
    const buttonText = breakpoint === 'large' || breakpoint === 'medium'
        ? t`Запросить письмо подтверждения`
        : t`Запросить письмо`;

    return (
        <section className={styles.section}>
            <SummaryHeader />
            <HeaderEmail
                title={t`Для завершения регистрации подтвердите почту!`}
                onClick={confirmEmail}
                buttonText={buttonText}
                icon={Email}
                button
            >
                <div>{t`Ссылка для подтверждения почты уже отправлена на адрес`}: {emailBold}</div>
                <div className={styles.red}>
                    {t`Если письма нет, проверьте папку`}
                    <span className={styles.bold}>
                        «{t`Спам`}»
                    </span>
                </div>
            </HeaderEmail>
            <AnswerEmail className={styles.button}/>
        </section>
    );
};

export default EmailWarning;